import { render, staticRenderFns } from "./PrintYearly.vue?vue&type=template&id=bc4772e4"
import script from "./PrintYearly.vue?vue&type=script&lang=js"
export * from "./PrintYearly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports